import type { ReadonlyDeep } from 'type-fest';
import { z } from 'zod';

export type VisionColorDetectorServiceAttributes = ReadonlyDeep<
  z.infer<typeof VisionColorDetectorServiceSchema>
>;

export const VisionColorDetectorServiceSchema = z
  .object({
    segment_size_px: z.number().optional(),
    hue_tolerance_pct: z.number(),
    saturation_cutoff_pct: z.number().optional(),
    value_cutoff_pct: z.number().optional(),
    detect_color: z.string().optional(),
  })
  .passthrough();
